import { Box } from '@cp/ds/src/components/box';
import { Typography } from '@cp/ds/src/components/typography';
import { CheckmarkIcon } from '@cp/ds/src/icons/checkmark';
import React from 'react';
import { hintList } from './const';

const LIST_ITEM_TOP_SPACING = '0.25rem';
const LIST_ITEM_ICON_RIGHT_SPACING = '8px';
const LIST_ITEM_ICON_SIZE = '1rem';

export const Hints: React.FC = () => {
  return (
    <Box sx={{ maxWidth: 520 }}>
      <Typography component="div" variant="body bold">
        Чтобы ускорить процесс обработки, обязательно выполните следующие рекомендации:
      </Typography>
      {hintList.map(({ title, description }, index) => (
        <Typography
          component="div"
          key={title}
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          sx={{ mt: index ? 0.75 : 1.5, position: 'relative', pl: `calc(${LIST_ITEM_ICON_SIZE} + ${LIST_ITEM_ICON_RIGHT_SPACING})` }}
          variant="body bold"
        >
          <CheckmarkIcon
            sx={{
              mr: LIST_ITEM_ICON_RIGHT_SPACING,
              fontSize: LIST_ITEM_ICON_SIZE,
              position: 'absolute',
              top: LIST_ITEM_TOP_SPACING,
              left: 0,
            }}
          />
          {title}
          <Typography variant="body">{description}</Typography>
        </Typography>
      ))}
    </Box>
  );
};
